import Head from 'next/head'
import styles from '../styles/pages/index.module.css'
import Layout from "../components/shared/layout/layout";
import Seo from "../components/shared/seo/seo";

import Recommandation from "../components/recommandation/recommandation";
import HorizontalScroll from "../components/carousel/horizontalScroll";
import Link from "next/link";
import {useAmp} from "next/amp";
import {useEffect} from "react";

export default function Home() {
    function showVideo() {
        document.getElementById("heroOverlay").classList.add("hidden");
        let video = document.getElementById("heroVideo");
        video.pause();
        let videoSource = document.getElementById("heroVideoSource");
        video.currentTime = 0;
        videoSource.src = "https://storagegisperg.blob.core.windows.net/bc-gisperg/videos/gisperg_header_full.mp4";
        video.controls = true;
        video.muted = false;
        video.loop = false;
        video.load();
        video.play();

        video.addEventListener('ended',myHandler,false);

        function myHandler(e) {
            document.getElementById("heroOverlay").classList.remove("hidden");
            video.pause();
            video.currentTime = 0;
            videoSource.src = "/videos/gisperg_header.mp4";
            video.controls = false;
            video.muted = true;
            video.loop = true;
            video.load();
            video.play();
        }
    }

    return (
      <Layout>
          <Seo
              description="1000 Momente in einem Glas. Weingut Johann Gisperg in der Thermenregion: Online-Shop, Heuriger, Termine und unsere Geschichte."
              path="/"
          />
          <Head>
              <link rel="preload" as="image" href="/images/poster.webp" fetchpriority="high" />
          </Head>
          <section>
              <div className={styles.videoContainer}>
                  <video id="heroVideo" poster="/images/poster.webp" preload="auto" className={styles.video} autoPlay="autoPlay" loop={true} muted={true} playsInline>
                    <source id="heroVideoSource" src="/videos/gisperg_header.mp4" type="video/mp4"/>
                    <track kind="captions" src="/videos/captions.de.vtt" srcLang="de" label="Deutsch" default/>
                </video>
            </div>
            <div id="heroOverlay"className={styles.contentContainer}>
                <div>
                    <p className="phrase white">Nehmen Sie sich Zeit und genießen Sie...</p>
                    <h1 className="white" style={{margin: '0'}}>1000 Momente in<br/> einem Glas</h1>
                </div>
                <div className="horizontal" style={{marginBottom:"100px"}}>
                    <div className="col-6 right">
                        <Link href="/weinkauf/shop"><p className="button primary x2">Zum Online-Shop</p></Link>
                    </div>
                    <div className="col-6 left">
                        <p className="secondary dark x2 button" onClick={showVideo}>Film ab</p>
                    </div>
                </div>
                <div className="bottom jump">
                    <p className="white annotation">Mehr entdecken</p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20.447" height="14.108" viewBox="0 0 20.447 14.108">
                        <g id="Path_2714" data-name="Path 2714" transform="translate(20.447 14.108) rotate(180)" fill="#fff" opacity="0.996">
                            <path d="M 18.02375411987305 12.46822452545166 L 10.46737289428711 10.56914901733398 L 10.2236328125 10.50788879394531 L 9.979892730712891 10.56914901733398 L 2.42351222038269 12.46822452545166 L 10.2236328125 1.704217672348022 L 18.02375411987305 12.46822452545166 Z" stroke="none"/>
                            <path d="M 10.2236328125 3.408422470092773 L 4.847009658813477 10.82805252075195 L 10.2236328125 9.476789474487305 L 15.60025596618652 10.82805252075195 L 10.2236328125 3.408422470092773 M 10.2236328125 -9.5367431640625e-07 L 20.44726371765137 14.10839939117432 L 10.2236328125 11.53898906707764 L 1.9073486328125e-06 14.10839939117432 L 10.2236328125 -9.5367431640625e-07 Z" stroke="none" fill="#fff"/>
                        </g>
                    </svg>
                </div>
            </div>
        </section>
          <section className="background_light_texture" style={{justifyContent:'start'}}>
            <div className="horizontal">
                <div className="col-6 top">
                    <h2>Die schönsten Momente sind doch die, in denen man sich dazu entscheidet, das Leben einfach zu genießen.</h2>
                </div>
                <div className="col-6 top">
                    <h2>Das Ganze ist mehr als die Summe seiner Teile.</h2>
                </div>
            </div>
              <div className="horizontal">
                  <div className="col-6 top">
                      <p>Wenn terminüberflutete Kalender die Tage bestimmen, Treffen mit Freunden und Familie langfristig geplant werden müssen und man nach einem langen Arbeitstag nur noch rasch Erledigungen macht oder zum Sport hetzt, wird es Zeit auf Pause zu drücken und sich eine Auszeit vom Alltagsstress zu gönnen. </p>
                  </div>
                  <div className="col-6 top">
                      <p>Oft sind es die kleinen Dinge, die wir viel mehr und bewusster genießen sollten. Sei es das wohlig warme Gefühl beim Eintauchen in die heiße Badewanne, der Duft des Lieblingsgerichtes, der einem bereits beim Kochen das Wasser im Mund zusammenlaufen lässt oder das Glas Wein, mit dem man mit seinen Liebsten auf die großen und kleinen Momente im Leben anstößt.
                      </p>
                  </div>
              </div>
              <img alt=""  className={styles.transition_image} src="/images/wine_smell.webp" width="1076" height="606"/>
          </section>
          <section className="background_light vertical-center">
            <div className={`horizontal ${styles.after_transition}`}>
                <div className="col-4 center-text">
                    <h3>Sehen</h3>
                    <p>Wer das Glas schwenkt und ins Licht hält,  sieht die Sonnenstrahlen, die den Rebstock Kraft zum Wachsen geben. </p>
                </div>
                <div className="col-4 center-text">
                    <h3>Riechen</h3>
                    <p>Wer seine Nase behutsam in ein Glas Wein steckt, riecht den lang ersehnten Regen im heißen Sommer auf den Steinen. </p>
                </div>
                <div className="col-4 center-text">
                    <h3>Schmecken</h3>
                    <p>Wer einen Schluck macht und spürt, wie sich dieser im Mund verteilt, schmeckt den Boden, in dem der Rebstock verwurzelt ist. </p>
                </div>
            </div>
              <p className="phrase brown">Wer ein Glas Wein bewusst genießt,<br/>
                  entdeckt 1000 Momente in einem Glas. </p>
          </section>
          <div className="transition_div horizontal">
              <div className="col-3"><h3 className="white">Tauchen Sie in unsere Genusswelt ein</h3></div>
              <div className="col-3">
                  <Link href="/herkunft"><p className="white annotation marker link">Herkunft spüren</p></Link>
              </div>
              <div className="col-3">
                  <Link href="/termine#heurigen"><p className="white annotation marker link">Heurigen geniessen</p></Link>
              </div>
              <div className="col-3">
                 <Link href="/kontakt/#besuchamweingut"><p className="white annotation marker link">Besuch am Weingut</p></Link>
              </div>
          </div>
          <section className="background_light vertical-center">
              <div className="col-12">
                <h2 className="center-text">Mit besten<br/> Empfehlungen von</h2>
              </div>
              <div style={{maxWidth:"1200px"}}>
              <HorizontalScroll style="scrollbar_dark">
                    <Recommandation image="/images/prices/price_vinaria.webp"
                                    quote="Beeindruckend ist die Pinot-Performance … wo schon die Klassik enorm viel Wein bietet."
                                    prices='4 Kronen Weingut | Trophy-Sieger St. Laurent  und mehrere Bewertungen mit dem Prädikat Weltklasse |  zahlreiche Best Buy’s & Toplist Platzierungen'/>
                    <Recommandation image="/images/prices/price_genuss.webp"
                                    quote="Seine Weine überzeugen mit sensationellem Preis-Genuss-Verhältnis, dabei ist Hans immer auf der Suche nach Größe im Wein"
                                    prices='Wein.Pur.Pionier 2019 | Mehrfacher Trophy-Sieger | Mehrere Bewertungen mit dem Prädikat Weltklasse'/>
                    <Recommandation image="/images/prices/price_falstaff.webp"
                                    quote="Best of Youngsters."
                                    prices='Mehrere Sortensieger & Stockerlplätze in den Kategorien St. Laurent, Pinot Noir, Zweigelt, Merlot sowie mehrere Best buy’s & Toplist Platzierungen'/>

                    <Recommandation image="/images/prices/price_gault.webp"
                                    quote="Mustergültig ist die Pinot Noir Reserve … elegant und tiefgründig zugleich."
                                    prices="Mehrfache 18/20 Punkte Bewertungen"/>
                    <Recommandation image="/images/prices/price_vineus.webp"
                                    quote="Newcomer des Jahres"/>
                    <Recommandation image="/images/prices/price_alacarte.webp"
                                    quote="Zweifacher Sieger"
                                    prices="Mehrfacher 'Grand Cru' Sieger"/>
                    <Recommandation image="/images/prices/price_salon.webp"
                                    quote="Mehrfacher Landessieger und mehrere Salon-Weine"/>
              </HorizontalScroll>
              </div>
              <div className="col-12">
                  <Link href="/news#auszeichnungen"><p className="button secondary x3 uppercase">Auszeichnungen</p></Link>
              </div>
          </section>
          <div className="transition_div horizontal">
              <div className="col-4"><h3 className="white">Wir nehmen Ihnen Arbeit ab und erleichtern Ihren Einkauf</h3></div>
              <div className="col-2-4">
                  <Link href="/weingut/sortiment"><p className="white annotation marker link center-text">Weine entdecken</p></Link>
              </div>
              <div className="col-2-4">
                  <Link href="/weinkauf#lieferfahrt"><p className="white annotation marker link center-text">Persönliche Lieferung</p></Link>
              </div>
              <div className="col-2-4">
                  <Link href="/kontakt"><p className="white annotation marker link center-text">Wir beraten Sie gerne</p></Link>
              </div>
          </div>
          <section className="background_light vertical-center">
              <div className="horizontal vertical-center">
                  <div className="col-2-4 left">
                      <h2 style={{marginBottom:"5px", marginTop:"5px"}}>Unsere <br/> Mission</h2>
                      <p style={{marginBottom:"5px", marginTop:"5px"}} className="information brown">Nachhaltig freude & <br/> Bewusstsein schaffen</p>
                  </div>
                  <div className="col-4">
                      <p>Es ist uns ein Anliegen, demjenigen, der unsere Weine trinkt, zu vermitteln, dass er mehr als ein Glas Wein in Händen hält. Ein Glas Wein fasst die 1000 Momente, bis wir als Winzer unser Werk eines Jahres in die Flaschen füllen, ebenso wie die 1000 Momente, die der Trinkende dabei erleben kann.</p>
                  </div>
                  <div className="col-4">
                      <p> Mit einem Glas Wein teilen wir unsere Leidenschaft, unsere Emotionen und die Erfahrung von Generationen.<br/>
                          Bewusstes Wahrnehmen und Genießen lädt zu einer großen Entdeckungsreise im kleinen Weinglas. </p>
                  </div>
              </div>
              <div className="col-12">
                 <Link href="/weingut/werte"><p className="button secondary x2">Unser Weg</p></Link>
              </div>
          </section>
              <section className="background_lighter">
              <div className="horizontal">
                  <div className="col-6">
                      <img alt=""  src="/images/newsletter.webp" style={{width:"100%"}} width="1400" height="777"/>
                  </div>
                  <div className="col-6" style={{alignItems:'start !important', justifyContent:'center'}}>
                      <p className="phrase brown" style={{marginTop:'20px'}}>Abonnieren Sie unseren Newsletter, um nichts mehr zu verpassen!</p>
                      <Link href="/kontakt/#formular"><p className="button primary x2">Abonnieren</p></Link>
                  </div>
              </div>

          </section>
      </Layout>
  )
}